<template>
  <div class="tw-w-full tw-bg-gray-light tw-rounded tw-mt-6 tw-mb-20">
    <button
      type="submit"
      class="tw-w-full tw-text-sm tw-text-secondary-dark tw-p-4 tw-px-14"
    >
      {{ title }}
    </button>
  </div>
</template>

<script>
export default {
  name: "OnboardingGrayBtn",

  emits: ["btnClicked"],

  props: {
    title: { type: String, default: () => "", required: true },
  },
};
</script>

<style lang="scss" scoped></style>
